var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueprintAppLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5255_323049)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "#2D54E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1182 37.1533V7.5H12.6875V37.1107C12.6875 37.1107 12.6875 37.12 12.6875 37.1255C12.6875 37.1311 12.6875 37.1348 12.6875 37.1404C12.6912 41.7766 14.3935 45.9758 17.1182 49.3062C17.5294 49.8082 17.9832 50.2694 18.4315 50.7362L21.5544 47.6132C21.4266 47.4854 21.2747 47.3854 21.1506 47.2539C18.6741 44.5958 17.1256 41.0598 17.1182 37.1515V37.1533Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.0255 17.7839C31.2049 17.7839 30.3954 17.8376 29.6027 17.9358V22.4591C30.3954 22.3276 31.1956 22.2146 32.0255 22.2146C40.2478 22.2146 46.9364 28.9032 46.9364 37.1255C46.9364 45.3479 40.2478 52.0365 32.0255 52.0365C29.5323 52.0365 27.2169 51.3641 25.1498 50.2768L21.8971 53.5331C24.8497 55.3595 28.2987 56.4635 32.0255 56.4635C42.7058 56.4635 51.3652 47.804 51.3652 37.1237C51.3652 26.4434 42.7058 17.7839 32.0255 17.7839Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.211 42.8954C42.2649 41.221 42.8984 39.2538 42.8984 37.1274C42.8984 31.1223 38.0306 26.2544 32.0254 26.2544C31.1938 26.2544 30.3917 26.3674 29.6138 26.5434V31.1704C30.3602 30.8667 31.1715 30.6814 32.0254 30.6814C35.5781 30.6814 38.4696 33.5729 38.4696 37.1255C38.4696 38.0184 38.2862 38.8667 37.9565 39.6391L41.211 42.8936V42.8954Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5795 45.8406C25.5795 45.8406 25.5813 45.8406 25.5813 45.8424C26.7687 46.7223 28.1245 47.3724 29.6138 47.7095C30.3917 47.8855 31.1938 47.9985 32.0255 47.9985C34.3001 47.9985 36.408 47.2965 38.1528 46.1017L34.8798 42.8287C34.0093 43.2677 33.0646 43.5697 32.0255 43.5697C31.1697 43.5697 30.3602 43.3863 29.6138 43.0807C27.2558 42.123 25.5813 39.8225 25.5813 37.1255V7.5H21.1488V37.0978H21.1525C21.1525 37.107 21.1488 37.1144 21.1488 37.1237C21.1488 40.706 22.9066 43.8549 25.5795 45.8369V45.8406Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5255_323049"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 12.8,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueprintAppLogo);
export default __webpack_public_path__ + "static/media/blueprint-app-logo.cd0185cd4909753be3ccf15d8f963a7a.svg";
export { ForwardRef as ReactComponent };